import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  RightSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

import { HeaderLoading } from './header-loading';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} />

      <Container>
        <LeftSection>
          <HeaderLoading />
          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 h-16" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12" />
              <InputSkeleton className="col-span-12 h-16" />
            </FormLayout>
          </CardContainer>
        </LeftSection>

        <RightSection>
          <CardContainer right>
            <SectionHeadingSkeleton />
            <PhoneNumberLoading />
          </CardContainer>
          <CardContainer right>
            {/* // ken asked for it */}
            <SectionHeadingSkeleton />
            <PhoneNumberLoading />
          </CardContainer>
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
